import React, { useContext as useContextCore, useState } from 'react'
import type { Dispatch, SetStateAction } from 'react'
import type { State } from '@ztechapps/common.hook'
import type { PasskeyAuth } from '@ztechapps/common.contract'
import type { UseListPasskeysResult } from './useListPasskeys'
import { useListPasskeys } from './useListPasskeys'

export type PasskeyManagementProviderProps = {
  apiBaseUrl: string
  children: React.ReactNode
}

export type PasskeyManagementContextType = {
  apiBaseUrl: string
  loading: State<boolean>
  error: State<string | null>
  selectedPasskey: [PasskeyAuth | null, Dispatch<SetStateAction<PasskeyAuth | null>>]
  listPasskeys: UseListPasskeysResult
}

const context = React.createContext<PasskeyManagementContextType>({} as PasskeyManagementContextType)
const CoreProvider = context.Provider

export const PasskeyManagementProvider = ({ children, ...props }: PasskeyManagementProviderProps) => {
  const loading = useState<boolean>()
  const error = useState<string | null>(null)
  const selectedPasskey = useState<PasskeyAuth | null>(null)

  const listPasskeys = useListPasskeys({
    apiBaseUrl: props.apiBaseUrl,
  })

  return <CoreProvider value={{ ...props, listPasskeys, loading, error, selectedPasskey }}>{children}</CoreProvider>
}

export const usePasskeyManagementContext = () => useContextCore(context)
